import { Footer, Menu, PageContainer, Seo } from "~components";
import { Layout } from "~components/common/Layout";
import { EventsCalendar } from "~components/calendar/calendar";
import { useRouter } from "next/router";
import { CalendarHomepageCustomizationDocument } from "~graphql/typed-document-nodes";
import { useQuery } from "~hooks/useQuery";
import { SlateRenderer } from "~components/common/Slate/SlateRenderer";
import { Box, Divider, Text } from "flicket-ui";

const CalendarHomePage = () => {
  const router = useRouter();

  const { data } = useQuery(CalendarHomepageCustomizationDocument);

  const customization = data?.calendarHomepageCustomization;

  function handleSelectEvent(eventId: string) {
    void router.push({
      pathname: `/events/[eventId]/reservation`,
      query: {
        ...router.query,
        eventId: eventId,
      },
    });
  }

  return (
    <>
      <Seo title={customization?.title || "Events calendar"} />

      <Layout
        layoutType="main"
        css={`
          padding-top: 0 !important;
        `}
      >
        <Menu sticky={false} />

        <PageContainer
          bannerImage={customization?.banner || null}
          footer={<Footer />}
          containerProps={{
            pt: 3,
            minHeight: { _: 0, md: "320px" },
          }}
        >
          {customization?.title && (
            <Box mb={4}>
              <Text
                variant="header.L"
                as="h1"
                textAlign="left"
              >
                {customization.title}
              </Text>

              <Divider mt={4} />
            </Box>
          )}

          {customization?.description && (
            <Box mb={4}>
              <SlateRenderer value={customization.description} />
            </Box>
          )}

          <EventsCalendar handleSelectEvent={handleSelectEvent} />
        </PageContainer>
      </Layout>
    </>
  );
};

export default CalendarHomePage;
